import "./TheEngine.module.css";
import EduSproutHeader from "@/reusable_sections/Header";
import TheTechStack from "./sections/TheTechStack";
import FromLogicToLaunch from "./sections/FromLogicToLaunch";
import ReadyToUpgrade from "./sections/ReadyToUpgrade";
import PlatformFooter from "@/reusable_sections/Footer";
export default function TheEnginePage() {
  return <div>
      <EduSproutHeader />
      <TheTechStack />
      <FromLogicToLaunch />
      <ReadyToUpgrade />
      <PlatformFooter />
    </div>;
}